const apiStatus = {
  success: "Success",
  failure: "Failure",
};

export default apiStatus;
